import React from 'react';
import { initializeIcons } from '@uifabric/icons';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ShortCutPaneComponent } from './component';
import { messageService } from '../../../services/messageService';
import { VisualPlanListPaneFilter, VPShortCutPaneItem } from '../../../types/visualPlan';

initializeIcons();

interface Props extends WithTranslation {
  shortCutPaneFilters: VPShortCutPaneItem[];
  handelShortCutPaneFilter: (selectedItem: VPShortCutPaneItem) => void;
  filter: VisualPlanListPaneFilter;
  projectId: string | null;
  toggleOverlay: boolean;
  resetLayout: boolean
}

interface State {
  divClass: string;
  selectedCodeType: number;
  currentActiveSection: string | null;
}

class ShortCutPane extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      divClass: 'vp filter-panel-left',
      selectedCodeType: -1,
      currentActiveSection: '0',
    };
  }

  componentDidMount() {
    if (this.state.divClass === 'vp filter-panel-left') {
      if (window.innerWidth > 1300) {
        messageService.sendMessage({ shortCutPaneExpanded: true });
      }
    } else {
      messageService.sendMessage({ shortCutPaneExpanded: false });
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.toggleOverlay !== prevProps.toggleOverlay) {
      if (this.props.toggleOverlay) {
        this.setState({ divClass: 'vp filter-panel-left panel-move' });
      } else {
        this.setState({ divClass: 'filter-panel-left' });
      }
    }
    // if(this.props.resetLayout !==prevProps.resetLayout){
    //   if(this.props.resetLayout){
    //     this.setState({ divClass: 'filter-panel-left' });
    //   }
    // }
  }


  private handelShortCutPaneFilter = (selectedItem: VPShortCutPaneItem) => {
    this.setState({
      currentActiveSection: selectedItem.value,
    });
    let filter: VisualPlanListPaneFilter = new VisualPlanListPaneFilter();

    // history.push({
    //   pathname: `/CU/${getContractingUnit()}/project/${getProject()}/project-molecule`,
    //   state: { pmolFilter: filter },
    // });
    // messageService.sendMessage({
    //   pbsFilter: filter,
    // });

    this.props.handelShortCutPaneFilter(selectedItem);
  };

  private resetFilter = () => {
    let filterItem: VPShortCutPaneItem = {
      value: null,
      id: null,
      type: null,
      name: 'All',
      key: null,
    };
    this.setState({
      currentActiveSection: null,
    });

    this.props.handelShortCutPaneFilter(filterItem);
  };

  public render(): JSX.Element {
    return (
      <ShortCutPaneComponent
        currentActiveSection={this.state.currentActiveSection}
        toggleOverlay={this._toggleOverlay}
        shortCutPaneFilters={this.props.shortCutPaneFilters}
        toggleOverlayFwd={this._toggleOverlayFwd}
        handelShortCutPaneFilter={(selectedItem: VPShortCutPaneItem) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        resetFilter={() => this.resetFilter()}
        divClass={this.state.divClass}
      />
    );
  }

  private _toggleOverlay = (): void => {
    this.setState({ divClass: 'filter-panel-left panel-move' });
  };
  private _toggleOverlayFwd = (): void => {
    this.setState({ divClass: 'filter-panel-left' });
  };
}


export default withTranslation()(ShortCutPane);
